/**
 * Maps crypto-pro / CAdES plugin errors to user-facing messages.
 * Raw Error: prefix is stripped before matching.
 */
export function mapCryptoProError(error: unknown): string {
  const raw = String(error).replace(/^Error:\s*/i, '');

  if (
    /не подключен модуль|инициализации модуля|подключении модуля|cades plugin|загрузке плагина/i.test(
      raw
    )
  ) {
    return (
      'Не установлен или не подключен плагин КриптоПро ЭЦП Browser plug-in. ' +
      'Для Яндекс.Браузера нужно расширение из Opera store.'
    );
  }

  if (/не поддерживаемая версия (плагина|csp)/i.test(raw)) {
    return 'Неподдерживаемая версия плагина или КриптоПро CSP';
  }

  if (/хранилищ/i.test(raw)) {
    return 'Ошибка доступа к хранилищу сертификатов';
  }

  if (/нет доступных сертификатов/i.test(raw)) {
    return (
      'Нет сертификатов с закрытым ключом, действительных на текущую дату ' +
      '(проверьте PrivateKey Link в certmgr)'
    );
  }

  return raw || 'Неизвестная ошибка при работе с ЭП';
}
